<mat-dialog-content class="app-physical-examination-dialog__content">
    <div>
        <h2 mat-dialog-title class="app-physical-examination-dialog__title">
            {{ 'apps.patient.overview.physicalExamination' | translate }}
        </h2>
        <app-physical-examination-form
            [formGroup]="physicalExaminationForm"
            [isBedSideMode]="data.isBedSideMode"
            [textareaMaxRows]="14"
            [isActive]="true"
        ></app-physical-examination-form>
    </div>

    <div class="app-physical-examination-dialog__actions">
        <button mat-button class="app-physical-examination-dialog__cancel" color="primary" mat-dialog-close>
            {{ 'apps.patient.overview.dialogCancel' | translate }}
        </button>
        <button mat-raised-button color="primary" cdkFocusInitial (click)="submitChange()">
            {{ 'apps.patient.overview.dialogSave' | translate }}
        </button>
    </div>
</mat-dialog-content>
